import { onErrorResumeNextStatic } from '../operators/onErrorResumeNext';

export const onErrorResumeNext = onErrorResumeNextStatic;



// WEBPACK FOOTER //
// ../../src/observable/onErrorResumeNext.ts